import { useEffect } from 'react'

export const useModalScroll = () => {
  useEffect(() => {
    document.body.style.position = 'fixed'
    document.body.style.top = `-${window.scrollY}px`
    document.body.style.right = '0'
    document.body.style.left = '0'

    const scrollY = document.body.style.top

    // enable scroll
    return () => {
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.right = ''
      document.body.style.left = ''
      window.scrollTo(0, parseInt(scrollY || '0') * -1)
    }
  }, [])
}
